const btnScrollToTop = document.querySelector(".back-to-top");

if (btnScrollToTop) {
    btnScrollToTop.addEventListener("click", (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
            console.log("Back To Top clicked");
        }, 1000);
    });
}
